import { render, staticRenderFns } from "./rich-text-content.vue?vue&type=template&id=f8cc0d22&scoped=true&"
import script from "./rich-text-content.vue?vue&type=script&lang=ts&"
export * from "./rich-text-content.vue?vue&type=script&lang=ts&"
import style0 from "./rich-text-content.vue?vue&type=style&index=0&id=f8cc0d22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8cc0d22",
  null
  
)

export default component.exports